<template>
    <div id="org_settings_content" class="pb-5">
        <!-- Mission Section -->
        <mission-settings 
            ref="missionSettings"
            :client="local_client" 
            :user="user">
        </mission-settings>

        <!-- Resources Section -->
        <resources-settings 
            :client="local_client" 
            :user="user">
        </resources-settings>

        <!-- Image Library Section -->
        <image-library-settings 
            :client="local_client" 
            :user="user">
        </image-library-settings>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import MissionSettings from './MissionSettings.vue';
import ResourcesSettings from './ResourcesSettings.vue';
import ImageLibrarySettings from './ImageLibrarySettings.vue';

export default defineComponent({
    name: 'ContentSettings',
    components: {
        MissionSettings,
        ResourcesSettings,
        ImageLibrarySettings,
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            local_client: {},
        };
    },
    beforeMount() {
        this.local_client = this.client;
    },
    mounted() {
        // Auto-resize textareas when component becomes visible
        this.$nextTick(() => {
            this.resizeAllTextareas();
        });
    },
    methods: {
        resizeAllTextareas() {
            // Call the resize method on the MissionSettings component
            if (this.$refs.missionSettings) {
                this.$refs.missionSettings.autoResizeAllTextareas();
            }
        }
    },
});
</script>
